import { isArray, isNumber, isObject, isString } from '../index.b2b';
import { core } from './core';

export function deepCompare(a: any, b: any, excludeKeys: Set<string> = null) {
    if ((isObject(a) || isArray(a)) && isString(b)) {
        b = core.parseJson(b);
    }
    if (isString(a) && (isObject(b) || isArray(b))) {
        a = core.parseJson(a);
    }
    let isObjects = isObject(a) && isObject(b);
    let isArrays = isArray(a) && isArray(b);
    let isNumbers = isNumber(a) && isNumber(b);
    if (!isObjects && !isArrays) {
        if (isNumbers) {
            return equalNumbers(a, b);
        }
        return a == b;
    }

    if (isArrays) {
        return compareArrays(a, b);
    }

    let objKeys1 = Object.keys(a);
    let objKeys2 = Object.keys(b);
    if (excludeKeys) {
        objKeys1 = objKeys1.filter(
            (key) => !excludeKeys.has(key) && typeof a[key] !== 'undefined'
        );
        objKeys2 = objKeys2.filter(
            (key) => !excludeKeys.has(key) && typeof b[key] !== 'undefined'
        );
    }

    if (objKeys1.length !== objKeys2.length) {
        return false;
    }

    for (const key of objKeys1) {
        let value1 = a[key];
        let value2 = b[key];

        if ((isObject(value1) || isArray(value1)) && isString(value2)) {
            value2 = core.parseJson(value2);
        }
        if (isString(value1) && (isObject(value2) || isArray(value2))) {
            value1 = core.parseJson(value1);
        }
        isObjects = isObject(value1) && isObject(value2);
        isArrays = isArray(value1) && isArray(value2);
        isNumbers = isArray(value1) && isArray(value2);

        if (isObjects && !deepCompare(value1, value2)) {
            return false;
        }
        if (isArrays && !compareArrays(value1, value2)) {
            return false;
        }
        if (!isObjects && !isArrays) {
            if (isNumbers) {
                if (!equalNumbers(value1, value2)) {
                    return false;
                }
            } else if (value1 !== value2) {
                return false;
            }
        }
    }
    return true;
}

function compareArrays(a: any[], b: any[]) {
    if (a.length !== b.length) {
        return false;
    }
    for (let i = 0; i < a.length; i++) {
        if (!deepCompare(a[i], b[i])) {
            return false;
        }
    }
    return true;
}

export function equalNumbers(a: number, b: number) {
    return Math.abs(a - b) < 200000000 * Number.EPSILON;
}
